//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'cardMember',
  components: {
      cmBlank,cmLoadmore
  },
  data () {
    return {
      title:'全部订单',
      isActive:0,
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      phone:'',
      uid:'',
      pageFlag:2,
      i:0,
      hasNext:0,
      lastId:0,
      itemId:0,
      list:[],
    }
  },
  created(){
    this.i = Number(this.$route.params.i);
    switch(this.i){
      case 1:
        this.title = '即将过期';
        break;
      case 2:
        this.title = '已过期会员';
        break;
      default:
        this.title = '会员用户';
        break;
    }
  },
  amount(){
  },
  methods:{
    reset(){
        this.list = [];
        this.phone = '';
        this.uid = '';
        this.pageFlag = 2;
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    copy(val){
        this.$func.copy(val,event);
    },
    getList(){
        this.$api.cardMember({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,i:this.i,uid:this.uid}).then((res)=>{
          if(res){
            // console.log(res);
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            res.data.forEach((item)=>{
                this.list.push(item);
            });
          }
        })  
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        // console.log(1111);
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/cardMember.vue